import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const List = async (): Promise<AxiosPromise<{ data: Types.IApi.Organization; }>> => {
  // const token = await getCaptchaToken()

  return http.request.get<{ data: Types.IApi.Organization }>(`/reference/organization/organizations-by-rating`, {
    // headers: {
    //   ...(token ? { 'X-Turnstile-Token': token } : null)
    // }
  });
};

export const Single = async ({ id }: { id: number }): Promise<AxiosPromise<{ data: Types.IApi.Organization; }>> => {
  const token = await getCaptchaToken()

  return http.request.get<{ data: Types.IApi.Organization }>(`/admin/handbook/organization-view/${id}`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    }
  });
};